import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconBrowseFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBrowseFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '7b5f0b8c73e634ac1da0da6f4537f630255bf4a8', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '3e1c0799fb72d724a9fa57ddb948375839f0b69b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '81738d9356d918e83b76906867b39ed42d1c5edc', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 4a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-14a.5.5 0 0 0-.5-.5zm16 1.5h1a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-1zM8.412 14.405a.594.594 0 0 1-.912-.502V9.097c0-.469.516-.753.912-.502l3.796 2.403a.594.594 0 0 1 0 1.004z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-browse-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-browse-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-browse-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBrowseFilled$1);
            }
            break;
    } });
}

const CosmosIconBrowseFilled = CosmosIconBrowseFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBrowseFilled, defineCustomElement };
